export default __webpack_public_path__ + "static/media/2497.b090ae5a.png";